import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ApironLanding from "@/components/ApironLanding";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ApironLanding />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
